/* eslint no-nested-ternary: 0 */
import React from 'react';
import { EVENTS } from '../../../utilities/CONSTANTS';
import InlineReference from './InlineReference';

class GithubIssueReference extends React.Component {
    state = { hasUpdatedGithubIssue: null };

    componentDidMount() {
        if (window.getGithubIssueData) {
            return this.getGithubIssueData();
        }
        window.addEventListener(EVENTS.GITHUB_TOKEN_LOADED, this.getGithubIssueData);
    }

    componentWillUnmount() {
        window.removeEventListener(EVENTS.GITHUB_TOKEN_LOADED, this.getGithubIssueData);
        if (this.activeRequest) {
            this.activeRequest.abort();
            this.activeRequest = null;
        }
    }

    getGithubIssueData = () => {
        if (this.state.hasUpdatedGithubIssue) return;
        const { contentState, entityKey } = this.props;
        const entityData = contentState.getEntity(entityKey).getData();
        const { apiUrl } = entityData;
        this.activeRequest = window.getGithubIssueData(apiUrl);
        this.activeRequest
            .then(({
                state,
                labels,
                comments,
                created_at,
                id,
                number,
                html_url: url,
                title,
                user: { login: githubUserName },
            }) => {
                const githubIssueData = {
                    url,
                    title,
                    id,
                    metadata: {
                        state,
                        labels,
                        comments,
                        created_at,
                        number,
                        githubUserName,
                    },
                };
                contentState.mergeEntityData(entityKey, githubIssueData);
                return this.setState({ hasUpdatedGithubIssue: true });
            });
    };

    render() {
        return <InlineReference cssSelector="github" showDetailsOnHover {...this.props} />;
    }
}

export default GithubIssueReference;
